(() => {
  if (customElements.get('td-editorial-header')) return;

  const ANALYTICS_VERSION = 'menu_v2';
  const MENU_IDS = {
    '/': 'home',
    '/collections/mas-vendidos': 'mas_vendidos',
    '/products/rampa-pendiente-suave': 'rampas',
    '/collections/living-impecable': 'cubre_sofas',
    '/collections/camas-para-perro': 'camas',
    '/collections/asientos-y-fundas-de-auto-para-perros': 'viaje',
    '/collections/comederos-y-accesorios-de-alimentacion-para-perro': 'comer_sin_desorden',
    '/products/the-dogs-nails-limador-electrico-silencioso-para-unas': 'unas_sin_estres',
    '/collections/all': 'todos_productos',
    '/collections/accesorios-esenciales': 'accesorios',
    '/pages/resenas-de-clientes-the-dogs': 'resenas',
    '/pages/politica-de-envio-the-dogs': 'envios_devoluciones',
    '/pages/contacto': 'contacto'
  };
  const linkId = path => {
    if (MENU_IDS[path]) return MENU_IDS[path];
    let hash = 2166136261;
    for (let i = 0; i < path.length; i++) hash = Math.imul(hash ^ path.charCodeAt(i), 16777619);
    return `link_${(hash >>> 0).toString(36)}`;
  };

  const analytics = (() => {
    const storageKey = 'td_header_analytics_v2_pending';
    const ttl = 30000;
    const unknownTtl = 1000;
    const maxPending = 20;
    let pending = [];
    let timer = 0;
    let started = false;
    let restored = false;
    let loadingPrivacy = false;
    let deniedSeen = false;
    let draining = false;
    const permission = () => {
      try {
        const privacy = window.Shopify?.customerPrivacy;
        if (typeof privacy?.analyticsProcessingAllowed !== 'function') return null;
        const allowed = privacy.analyticsProcessingAllowed() === true;
        if (!allowed) deniedSeen = true;
        return allowed;
      } catch (_) { return null; }
    };
    const removeStored = () => { try { window.sessionStorage.removeItem(storageKey); } catch (_) {} };
    const prune = () => {
      const now = Date.now();
      pending = pending.filter(item => now >= item.time && now - item.time < (item.allowed ? ttl : unknownTtl) && !(item.legacy && item.ga4 && item.clarity)).slice(-maxPending);
    };
    const persist = () => {
      if (permission() !== true) { removeStored(); return; }
      const accepted = pending.filter(item => item.allowed).slice(-maxPending);
      try {
        if (accepted.length) window.sessionStorage.setItem(storageKey, JSON.stringify(accepted));
        else window.sessionStorage.removeItem(storageKey);
      } catch (_) {}
    };
    const transportName = payload => {
      if (payload.event !== 'td_header_navigation_click') return payload.event;
      const id = payload.menu_link_id;
      if (payload.location === 'mobile_header') return `td_header_mobile_${id}`;
      return `td_menu_${payload.location === 'mobile_menu' ? 'mobile' : 'desktop'}_${id}`;
    };
    const payloadFor = detail => {
      if (!detail || typeof detail.event !== 'string' || !/^td_header_[a-z_]+$/.test(detail.event)) return null;
      const payload = { event: detail.event, page_type: '', header_version: ANALYTICS_VERSION };
      ['page_type', 'location', 'category', 'destination', 'query_length', 'product_id', 'result_count', 'result_type', 'menu_link_id', 'link_path', 'variant_id', 'source_page_path', 'page_location', 'menu_click_time_ms'].forEach(key => {
        const value = detail[key];
        if (typeof value === 'string') payload[key] = value.slice(0, 200);
        else if (typeof value === 'number' && Number.isFinite(value)) payload[key] = value;
      });
      if (payload.event === 'td_header_navigation_click' && !/^[a-z0-9_]{1,24}$/.test(payload.menu_link_id || '')) return null;
      return payload;
    };
    const restore = () => {
      if (restored || permission() !== true) return;
      restored = true;
      try {
        const entries = JSON.parse(window.sessionStorage.getItem(storageKey) || '[]');
        if (Array.isArray(entries)) entries.slice(-maxPending).forEach(item => {
          const payload = payloadFor(item?.payload);
          if (payload && item.allowed === true && typeof item.time === 'number') {
            pending.push({ payload, time: item.time, allowed: true, legacy: item.legacy === true, ga4: item.ga4 === true, clarity: item.clarity === true });
          }
        });
      } catch (_) {}
      prune();
    };
    const schedule = () => {
      if (timer || !pending.length) return;
      timer = window.setTimeout(() => { timer = 0; drain(); }, 100);
    };
    const loadPrivacy = () => {
      if (loadingPrivacy || permission() !== null || typeof window.Shopify?.loadFeatures !== 'function') return;
      loadingPrivacy = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => { loadingPrivacy = false; drain(); });
      } catch (_) { loadingPrivacy = false; }
    };
    const drain = () => {
      if (draining) return;
      draining = true;
      try {
        prune();
        const allowed = permission();
        if (allowed === false) { pending = []; removeStored(); return; }
        if (allowed === null) { loadPrivacy(); return; }
        restore();
        for (const item of pending) {
          if (!item.allowed) {
            if (deniedSeen) continue;
            item.allowed = true;
          }
          if (permission() !== true) break;
          if (!item.legacy) {
            try {
              if (window.dataLayer === undefined) window.dataLayer = [];
              if (Array.isArray(window.dataLayer)) { window.dataLayer.push({ ...item.payload }); item.legacy = true; }
            } catch (_) {}
          }
          const name = transportName(item.payload);
          if (!item.ga4 && permission() === true && typeof window.gtag === 'function') {
            try {
              const { event, ...parameters } = item.payload;
              window.gtag('event', name, { ...parameters, send_to: 'G-KFV4JWZ31S' });
              item.ga4 = true;
            } catch (_) {}
          }
          if (!item.clarity && permission() === true && typeof window.clarity === 'function') {
            try { window.clarity('event', name); item.clarity = true; } catch (_) {}
          }
        }
        prune();
        persist();
      } finally { draining = false; schedule(); }
    };
    const start = () => {
      if (started) return;
      started = true;
      document.addEventListener('visitorConsentCollected', event => {
        pending = pending.filter(item => item.allowed);
        if (event.detail?.analyticsAllowed === false || permission() === false) {
          deniedSeen = true;
          pending = [];
          removeStored();
          return;
        }
        drain();
      });
      window.addEventListener('pageshow', drain);
      window.addEventListener('pagehide', persist);
      loadPrivacy();
      drain();
    };
    return {
      start,
      capture(detail) {
        start();
        const sourcePath = window.location.pathname || '/';
        const payload = payloadFor({ ...detail, source_page_path: sourcePath, page_location: window.location.origin + sourcePath, menu_click_time_ms: Date.now() });
        if (!payload) return;
        const allowed = permission();
        if (allowed === false || (allowed === null && deniedSeen)) return;
        pending.push({ payload, time: Date.now(), allowed: allowed === true, legacy: false, ga4: false, clarity: false });
        prune();
        drain();
      }
    };
  })();

  class TDEditorialHeader extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.navigation = this.querySelector('[data-td-navigation]');
      this.fallback = this.querySelector('[data-td-menu-fallback]');
      this.menuButton = this.querySelector('[data-td-menu-open]');
      this.menuDialog = this.querySelector('#td-header-menu-dialog');
      this.mobileSlot = this.querySelector('[data-td-mobile-slot]');
      this.desktopSlot = this.querySelector('[data-td-desktop-slot]');
      this.initAnalytics(options);
      if (!this.navigation || !this.menuDialog || typeof this.menuDialog.showModal !== 'function') return;
      this.desktopQuery = window.matchMedia('(min-width: 1200px)');
      this.menuOpen = false;
      this.overlayOpen = false;
      this.lastY = Math.max(window.scrollY, 0);
      this.direction = 0;
      this.distance = 0;
      this.frame = 0;
      this.setAttribute('data-enhanced', '');
      this.fallback.hidden = true;
      this.menuButton.hidden = false;
      this.syncNavigation();

      this.desktopQuery.addEventListener('change', () => this.syncNavigation(), options);
      this.menuButton.addEventListener('click', () => this.openMenu(), options);
      this.querySelector('[data-td-menu-close]').addEventListener('click', () => this.closeMenu(), options);
      this.menuDialog.addEventListener('close', () => this.finishMenuClose(), options);
      this.menuDialog.addEventListener('click', event => {
        if (event.target === this.menuDialog) {
          const rect = this.menuDialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeMenu();
        }
      }, options);

      this.navigation.addEventListener('toggle', event => {
        const opened = event.target;
        if (!opened.matches('[data-td-category]') || !opened.open) return;
        this.navigation.querySelectorAll('[data-td-category][open]').forEach(item => {
          if (item !== opened) item.open = false;
        });
        this.reveal();
        this.track({ event: 'td_header_category_open', location: this.menuOpen ? 'mobile_menu' : 'desktop_navigation', category: opened.querySelector('summary span')?.textContent.trim() || '' });
      }, { ...options, capture: true });

      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeCategories();
      }, options);
      document.addEventListener('focusin', event => {
        if (!this.contains(event.target)) this.closeCategories();
        if (this.announcement?.contains(event.target)) this.reveal();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const expanded = event.target.closest('[data-td-category][open]');
        if (expanded) {
          event.preventDefault();
          expanded.open = false;
          expanded.querySelector('summary').focus();
        }
      }, options);
      this.addEventListener('focusin', () => this.reveal(), options);
      document.addEventListener('td:header:search-opening', () => { this.closeMenu(false); this.closeCategories(); this.reveal(); }, options);
      document.addEventListener('td:header:overlay-change', event => {
        this.overlayOpen = Boolean(event.detail?.open);
        this.reveal();
        this.lastY = Math.max(window.scrollY, 0);
      }, options);
      window.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => { this.frame = 0; this.onScroll(); });
      }, { ...options, passive: true });
      window.addEventListener('pageshow', () => { this.reveal(); this.lastY = Math.max(window.scrollY, 0); }, options);
      this.resizeObserver = new ResizeObserver(() => this.measureStickyStack());
      this.resizeObserver.observe(this);
      this.syncAnnouncement();
      document.addEventListener('shopify:section:load', event => {
        if (event.target.id !== 'shopify-section-announcement-bar') return;
        this.syncAnnouncement();
        this.reveal();
      }, options);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target === this.announcement) this.releaseAnnouncement();
      }, options);
    }

    disconnectedCallback() {
      this.closeMenu(false);
      this.controller?.abort();
      this.controller = null;
      this.releaseAnnouncement();
      this.resizeObserver?.disconnect();
      if (this.frame) window.cancelAnimationFrame(this.frame);
    }

    syncNavigation() {
      this.closeMenu(false);
      this.closeCategories();
      (this.desktopQuery.matches ? this.desktopSlot : this.mobileSlot).appendChild(this.navigation);
      this.reveal();
    }

    syncAnnouncement() {
      const announcement = document.getElementById('shopify-section-announcement-bar');
      if (announcement !== this.announcement) {
        this.releaseAnnouncement();
        this.announcement = announcement;
        if (announcement) {
          announcement.dataset.tdHeaderSticky = this.dataset.sticky === 'false' ? 'false' : 'true';
          announcement.dataset.tdHeaderHidden = this.dataset.hidden || 'false';
          this.resizeObserver?.observe(announcement);
        }
      }
      this.measureStickyStack();
    }

    releaseAnnouncement() {
      if (this.announcement) {
        this.resizeObserver?.unobserve(this.announcement);
        delete this.announcement.dataset.tdHeaderSticky;
        delete this.announcement.dataset.tdHeaderHidden;
        this.announcement = null;
      }
      document.documentElement.style.setProperty('--td-announcement-height', '0px');
    }

    measureStickyStack() {
      const height = this.dataset.sticky === 'false' ? 0 : this.announcement?.offsetHeight || 0;
      document.documentElement.style.setProperty('--td-announcement-height', `${Math.ceil(height)}px`);
      document.documentElement.style.setProperty('--td-header-height', `${Math.round(this.offsetHeight)}px`);
    }

    openMenu() {
      if (this.desktopQuery.matches || this.menuDialog.open) return;
      this.reveal();
      this.hadOverflowLock = document.body.classList.contains('overflow-hidden');
      document.body.classList.add('td-header-menu-open', 'overflow-hidden');
      this.restoreMenuFocus = true;
      this.menuOpen = true;
      this.menuDialog.showModal();
      this.menuButton.setAttribute('aria-expanded', 'true');
      this.track({ event: 'td_header_menu_open', location: 'header' });
    }

    closeMenu(restoreFocus = true) {
      if (!this.menuDialog || !this.menuOpen) return;
      this.restoreMenuFocus = restoreFocus;
      if (this.menuDialog.open) this.menuDialog.close();
      this.finishMenuClose();
    }

    finishMenuClose() {
      if (!this.menuOpen) return;
      this.menuOpen = false;
      document.body.classList.remove('td-header-menu-open');
      if (!this.hadOverflowLock && !document.querySelector('dialog[open], cart-drawer.active')) document.body.classList.remove('overflow-hidden');
      this.menuButton.setAttribute('aria-expanded', 'false');
      this.closeCategories();
      this.reveal();
      if (this.restoreMenuFocus && !this.desktopQuery.matches) this.menuButton.focus({ preventScroll: true });
    }

    closeCategories() {
      this.navigation?.querySelectorAll('[data-td-category][open]').forEach(item => { item.open = false; });
    }

    reveal() {
      this.dataset.hidden = 'false';
      if (this.announcement) this.announcement.dataset.tdHeaderHidden = 'false';
      this.distance = 0;
    }

    onScroll() {
      const y = Math.max(window.scrollY, 0);
      const delta = y - this.lastY;
      this.lastY = y;
      if (this.dataset.sticky === 'false' || Math.abs(delta) < 2) return;
      if (y < 120 || this.menuOpen || this.overlayOpen || this.contains(document.activeElement) || this.announcement?.contains(document.activeElement) || this.querySelector('[data-td-category][open]') || document.body.classList.contains('overflow-hidden')) {
        this.reveal();
        return;
      }
      const direction = delta > 0 ? 1 : -1;
      if (direction !== this.direction) this.distance = 0;
      this.direction = direction;
      this.distance += Math.abs(delta);
      if (direction === 1 && this.distance > 40) {
        this.dataset.hidden = 'true';
        if (this.announcement) this.announcement.dataset.tdHeaderHidden = 'true';
      }
      if (direction === -1 && this.distance > 24) this.reveal();
    }

    initAnalytics(options) {
      this.setAttribute('data-td-analytics-version', ANALYTICS_VERSION);
      analytics.start();
      this.addEventListener('click', event => {
        const target = event.target;
        if (typeof target?.closest !== 'function') return;
        const link = target.closest('[data-td-header-nav]');
        if (link) {
          try {
            const url = new URL(link.href, window.location.origin);
            if (url.origin !== window.location.origin) return;
            const path = url.pathname.replace(/\/$/, '') || '/';
            const variant = /^\d{1,30}$/.test(url.searchParams.get('variant') || '') ? url.searchParams.get('variant') : '';
            const mobile = !window.matchMedia('(min-width: 1200px)').matches;
            const inMenu = Boolean(link.closest('[data-td-navigation], #td-header-menu-dialog'));
            const location = mobile ? (inMenu ? 'mobile_menu' : 'mobile_header') : 'desktop_navigation';
            this.track({ event: 'td_header_navigation_click', location, category: link.dataset.navLabel || '', menu_link_id: linkId(path), link_path: path, destination: path + (variant ? `?variant=${variant}` : ''), ...(variant ? { variant_id: variant } : {}) });
          } catch (_) {}
        }
        if (target.closest('[data-td-header-cart]')) this.track({ event: 'td_header_cart_open', location: 'header' });
      }, options);
      this.fallback?.addEventListener('toggle', () => {
        if (this.fallback.open && !this.fallback.hidden) this.track({ event: 'td_header_menu_open', location: 'header' });
      }, options);
      document.addEventListener('td:header:analytics', event => this.track(event.detail || {}), options);
    }

    track(detail) {
      analytics.capture({ ...detail, page_type: this.dataset.pageType || '' });
    }
  }
  customElements.define('td-editorial-header', TDEditorialHeader);
})();


